<template>
  <div class="container">
    <div class="main">
      <div class="top">
        <div class="xwdt">
          <div class="title">
            <img src="../../src/assets/images/xwdt.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="xwdtClick"/>
          </div>
          <div class="content borBox" @click="toNews(xwbdObj)">
            <img :src="xwbdObj.illustration" alt="" class="xwdtimg" />
            <div class="xwdtBottom">{{ xwbdObj.fName }}</div>
          </div>
        </div>
        <div class="grjj">
          <div class="title">
            <img src="../../src/assets/images/grjj.png" alt="" />
          </div>
          <div class="content twoborBox">
            <div class="grImg">
              <img :src="grjjObj.illustration" alt="" />
            </div>
            <div class="grRight">
              <div class="grNameBox">
                <span class="grName">王阶</span>
                <span class="grZw">教授</span>
              </div>
              <div class="r-right-content">
                {{ grjjObj.digest }}
              </div>
              <div class="ckxq" @click="personClick">【了解详情】</div>
            </div>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="mscz">
          <div class="title">
            <img src="../../src/assets/images/mscz.png" alt="" />
          </div>
          <div class="content">
            <img src="../../src/assets/images/cz.png" alt="" class="msczImg"/>

          </div>
        </div>
        <div class="gzsjj">
          <div class="title">
            <img src="../../src/assets/images/gzsjj.png" alt="" />
          </div>
          <div class="content borBox">
            <div class="gzsjsbox-content">
              {{ gzsjsObj.digest }}
            </div>
            <div class="ckxq" @click="gzsClick">【了解详情】</div>
          </div>
        </div>
        <div class="gzscy">
          <div class="title">
            <img src="../../src/assets/images/gzscy.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="cyjjClick"/>
          </div>
          <div class="content borBox">
            <div class="cyItem" v-for="(item, ind) in info['2_cyjj']" :key="ind" @click="toCyjj(item)">{{ item.fName }}
            </div>
          </div>
        </div>
      </div>
      <div class="bottom1">
        <div class="dzyj">
          <div class="title">
            <img src="../../src/assets/images/dzyj.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="dzyjClick"/>

          </div>
          <div class="content borBox">
            <div class="dzyjitem" v-for="(item, index) in info['3_dzyj']" :key="index" @click="toDzyj(item)">
              <div class="dzyjPoint">
                <img src="../../src/assets/images/point.png" alt="" />
              </div>
              <div class="dzyjname" :title="item.fName">{{ item.fName }}</div>
            </div>
          </div>
        </div>
        <div class="jyzj">
          <div class="title">
            <img src="../../src/assets/images/jyzj.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="jyzjClick"/>
          </div>
          <div class="content borBox">
            <div class="dzyjitem" v-for="(item, index) in info['4_jyzj']" :key="index" @click="toExp(item)">
              <div class="dzyjPoint">
                <img src="../../src/assets/images/point.png" alt="" />
              </div>
              <div class="dzyjname" :title="item.fName">{{ item.fName }}</div>
            </div>
          </div>
        </div>
        <div class="dxba">
          <div class="title">
            <img src="../../src/assets/images/dxba.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="dxbaClick"/>
          </div>
          <div class="content borBox">
            <div class="dzyjitem" v-for="(item, index) in info['5_dxbl']" :key="index" @click="toCase(item)">
              <div class="dzyjPoint">
                <img src="../../src/assets/images/point.png" alt="" />
              </div>
              <div class="dzyjname" :title="item.fName">{{ item.fName }}</div>
            </div>
          </div>
        </div>

      </div>
      <div class="bottom1">
        <div class="xscj">
          <div class="title">
            <img src="../../src/assets/images/xscj.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="xscjClick"/>
          </div>
          <div class="content borBox">
            <div class="dzyjitem" v-for="(item, index) in info['6_xscj']" :key="index" @click="toAchieve(item)">
              <div class="dzyjPoint">
                <img src="../../src/assets/images/point.png" alt="" />
              </div>
              <div class="dzyjname" :title="item.fName">{{ item.fName }}</div>
            </div>
          </div>
        </div>
        <div class="spzl">
          <div class="title">
            <img src="../../src/assets/images/spzl.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="spzlClick"/>
          </div>
          <div class="content borBox"  @click="toSp(spzlObj)">
            <img :src="spzlObj.e0" alt="" class="xwdtimg" />
            <div class="xwdtBottom">{{ spzlObj.vName }}</div>
            <div class="video">
                <img src="../../src/assets/images/video.png" alt="" />
              </div>
          </div>
        </div>
        <div class="mtbd">
          <div class="title">
            <img src="../../src/assets/images/mtbd.png" alt="" />
            <img src="../../src/assets/images/more.png" alt="" class="moreImg" @click="mtbdClick"/>
          </div>
          <div class="content borBox">
            <div class="dzyjitem" v-for="(item, index) in info['8_mtbd']" :key="index" @click="toDetail(item)">
              <div class="dzyjPoint">
                <img src="../../src/assets/images/point.png" alt="" />
              </div>
              <div class="dzyjname" :title="item.fName">{{ item.fName }}</div>
              
            </div>
          </div>
        </div>

      </div>
    </div>
    <el-backtop ref="scrollbar" :bottom="100" :right="0"></el-backtop>
  </div>
</template>
<script>
import API from '../../apis/index'
import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation]);
export default {
  name: "Topic",
  components: {
    // CarouselCopy,
  },
  data() {
    return {
      info: {},
      grjjObj: {},
      gzsjsObj: {},
      cyjjList: [],
      dzyjList: [],
      jyList: [],
      dxbaList: [],
      mtbdList: [
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
        {
          title: "全国首个中西医整合食管癌专业委员会成立！河南中医药大…",
          time: "2022.10.07",
        },
      ],
      spzlList: [],
      jyzjObj: {},
      jyzjList: [],
      xscjObj: {},
      xscjList: [],
      xwbdObj: {},
      xwbdList: [],
      spzlObj: {}
    };
  },
  mounted() {
    const currentRouter = {
      name: "王阶全国名老中医药专家传承工作室",
      path: "/topic",
    };
    localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    // this.$refs.scrollbar.wrap.scrollTop = 0

  },
  created() {
    this.init()
  },
  methods: {
    init() {
      console.log(API.getHome)
      this.$http.get(API.getHome).then(res => {
        console.log(res.data.data)
        this.info = res.data.data
        this.grjjObj = res.data.data['0_grjj'][0]
        this.gzsjsObj = res.data.data["1_gzsjs"][0]
        this.jyzjList = res.data.data["4_jyzj"].slice(1)
        this.jyzjObj = res.data.data["4_jyzj"][0]
        this.xscjList = res.data.data["6_xscj"].slice(1)
        this.xscjObj = res.data.data["6_xscj"][0]
        this.xwbdList = res.data.data["9_xwdt"].slice(1)
        this.xwbdObj = res.data.data["9_xwdt"][0]
        this.spzlObj = res.data.data["11_spzl"][0]
        this.$nextTick(() => {
          new Swiper(".swiper-container", {
            width: 216,
            spaceBetween: 34,
            freeMode: true,
            loop: true,
            loopAdditionalSlides: 2,
            loopedSlides: 4,
            navigation: {
              nextEl: ".next",
              prevEl: ".pre",
            },
          });
        });
      })
      this.$http.get(`${API.getVideo}?pageNum=1&pageSize=7`).then(res => {
        console.log(res.data.data)
        this.spzlList = res.data.data.list
      })
    },
    preCyjj() {
      console.log(this.$refs.cyjjList);
    },
    nextCyjj() {
      console.log(this.$refs.cyjjList);
    },
    toCyjj(item) {
      const params = {
        fId: item.fId
      }
      this.$router.push({
        path: '/memberDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toDzyj(item) {
      const params = {
        fId: item.fId
      }
      console.log(params)
      this.$router.push({
        path: '/pupilDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toExp(item) {
      const params = {
        fId: item.fId
      }
      console.log(params)
      this.$router.push({
        path: '/expDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toCase(item) {
      const params = {
        fId: item.fId
      }
      console.log(item)
      this.$router.push({
        path: '/caseDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toAchieve(item) {
      const params = {
        fId: item.fId
      }
      console.log(item)
      this.$router.push({
        path: '/achieveDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toTalent(item) {
      const params = {
        fId: item.fId
      }
      console.log(item)
      this.$router.push({
        path: '/talentDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toNews(item) {
      const params = {
        fId: item.fId
      }
      console.log(item)
      this.$router.push({
        path: '/newsDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toDetail(item) {
      console.log(item)
      window.open(item.details, '_blank');
    },
    toSp(item) {
      window.open(item.url, '_blank');
    },
    personClick() {
      this.$router.push({
        path: "/personInfo",
        query: {},
      });
      const currentRouter = {
        name: "个人简介",
        path: "/personInfo",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    gzsClick() {
      this.$router.push({
        path: "/studio",
        query: {},
      });
      const currentRouter = {
        name: "工作室介绍",
        path: "/studio",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    cyjjClick() {
      this.$router.push({
        path: "/memberInfo",
        query: {},
      });
      const currentRouter = {
        name: "成员简介",
        path: "/memberInfo",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    dzyjClick() {
      this.$router.push({
        path: "/pupil",
        query: {},
      });
      const currentRouter = {
        name: "弟子业绩",
        path: "/pupil",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    jyzjClick() {
      this.$router.push({
        path: "/exp",
        query: {},
      });
      const currentRouter = {
        name: "经验总结",
        path: "/exp",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    dxbaClick() {
      this.$router.push({
        path: "/case",
        query: {},
      });
      const currentRouter = {
        name: "典型病案",
        path: "/case",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    xscjClick() {
      this.$router.push({
        path: "/achieve",
        query: {},
      });
      const currentRouter = {
        name: "学术成就",
        path: "/achieve",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    rcpyClick() {
      this.$router.push({
        path: "/talent",
        query: {},
      });
      const currentRouter = {
        name: "人才培养",
        path: "/talent",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    mtbdClick() {
      this.$router.push({
        path: "/media",
        query: {},
      });
      const currentRouter = {
        name: "媒体报道",
        path: "/media",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    xwdtClick() {
      this.$router.push({
        path: "/news",
        query: {},
      });
      const currentRouter = {
        name: "工作室新闻动态",
        path: "/news",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    kpydClick() {
      this.$router.push({
        path: "/science",
        query: {},
      });
      const currentRouter = {
        name: "科普园地",
        path: "/science",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    spzlClick() {
      this.$router.push({
        path: "/video",
        query: {},
      });
      const currentRouter = {
        name: "视频专栏",
        path: "/video",
      };

      localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
  },
  beforeDestroy() {

  },
};
</script>
<style scoped>
.container {
  width: 1200px;
  overflow: hidden;
  padding: 0;
}

.main {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.top,
.middle,
.bottom1 {
  width: 100%;
  height: 270px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.xwdt,.mscz,.gzsjj,.gzscy,.dzyj,.jyzj,.dxba,.xscj,.spzl,.mtbd{
  width: 33%;
}
.grjj{
  width: 66%;
}
.msczImg{
  width: 100%;
}

.borBox {
  width: 100%;
  height: 224px;
  background: url("../../src/assets/images/borBox.png") no-repeat;
  background-size: 100% 100%;
  padding: 20px;
  position: relative;
}

.twoborBox {
  width: 100%;
  height: 224px;
  background: url("../../src/assets/images/twoborBox.png") no-repeat;
  background-size: 100% 100%;

}

.xwdt {
  display: flex;
  flex-direction: column;
}

.xwdt .content {
  cursor: pointer;
}
.spzl .content {
  cursor: pointer;
}
.title {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.moreImg{
  cursor: pointer;
}

.xwdtimg {
  width: 100%;
  height: 100%;
}

.xwdtBottom {
  position: absolute;
  bottom: 5px;
  left: 5px;
  width: calc(100% - 10px);
  height: 40px;
  background: url("../../src/assets/images/xwdtBottom.png") no-repeat;
  background-size: 100% 100%;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #E7DFD2;
  line-height: 40px;
  text-indent: 16px;
}

/* 个人简介 */
.grjj .content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.grImg img {
  width: 142px;
  height: 190px;
  margin-right: 20px;
}

.grName {
  font-size: 18px;
  font-family: SourceHanSerifCN, SourceHanSerifCN;
  font-weight: bold;
  color: #391603;
  line-height: 26px;
  margin-right: 2px;
}

.grZw {
  font-size: 12px;
  font-family: SourceHanSerifCN, SourceHanSerifCN;
  font-weight: bold;
  color: #7D6558;
  line-height: 17px;
}

.r-right-content {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 24px;
  text-align: justify;
}

.gzscy .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.cyItem {
  width: 90px;
  height: 20px;
  background: url("../../src/assets/images/cybac.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  cursor: pointer;
}

.dzyjPoint {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
}

.dzyjname {
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 37px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.video{
  position: absolute;
  top: 40%;
  left: 40%;
}

/******************************************* */
.titleBox {
  display: flex;
  justify-content: center;
}

.content-box {
  width: 1200px;
  margin: 43px auto 119px;
}

.grjjbox {
  height: 274px;
  background: url("../../src/assets/images/grjjbox.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 21px 46px 21px 21px;
}

.grjjbox .left {
  margin-right: 40px;
}

.grjjbox .right {
  display: flex;
}

.grjjbox .right .r-left {
  display: flex;
}

.grjjbox .right .r-left .r-left-left {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.grjjbox .right .r-left .r-left-left .r-left-left-top {
  display: flex;
  flex-direction: column;
  font-size: 22px;
  font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
  font-weight: bold;
  color: #391603;
  margin-bottom: 10px;
  margin-right: 10px;
  width: 20px;
}

.grjjbox .right .r-left .r-left-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.grjjbox .right .r-left .r-left-right .r-left-right-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  width: 10px;
  font-size: 7px;
  font-family: Helvetica-Bold, Helvetica;
  color: #391603;
  writing-mode: vertical-rl;
  margin-bottom: 5px;
}

.grjjbox .right .r-left .r-left-right .r-left-right-bottom {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  color: #391603;
  writing-mode: vertical-rl;
  margin-bottom: 5px;
  font-size: 14px;
  font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
  font-weight: bold;
  color: #7d6558;
}

.grjjbox .right .r-right {
  padding: 0 0 0 32px;
  border-left: 1px solid #eae0d5;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}


.ckxq {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #af1f23;
  cursor: pointer;
  float: right;
}

.gzsjsbox {
  height: 146px;
  background: url("../../src/assets/images/grjjbox.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 29px 46px;
}

.gzsjsbox-content {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 24px;
  text-align: justify;
}

.cyjjbox {
  position: relative;
  margin-bottom: 0;
}

.cyjjBox {
  overflow: hidden;
}

.cyjjList {
  display: flex;
  /* width: 1500px; */
}

.cyjjItem {
  width: 216px;
  height: 364px;
  /* margin-right: 50px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../../src/assets/images/cyjjbox.png") no-repeat;
  background-size: 100% 100%;
  padding: 21px;
  cursor: pointer;
}

.cyjjItem img {
  width: 180px;
}

.cyjjItem .name {
  margin: 16px auto 8px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #391603;
}

.cyjjItem .desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.pre {
  position: absolute;
  width: 48px;
  height: 48px;
  background: url("../../src/assets/images/pre.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  left: -60px;
  top: 167px;
}

.pre:hover {
  background: url("../../src/assets/images/next.png") no-repeat;
  background-size: 100% 100%;
  transform: rotate(180deg);
}

.next {
  position: absolute;
  background: url("../../src/assets/images/pre.png") no-repeat;
  background-size: 100% 100%;
  width: 48px;
  height: 48px;
  cursor: pointer;
  transform: rotate(180deg);
  right: -50px;
  top: 167px;
}

.next:hover {
  background: url("../../src/assets/images/next.png") no-repeat;
  background-size: 100% 100%;
  transform: rotate(0);
}

.more {
  width: 130px;
  height: 40px;
  line-height: 40px;
  margin: 40px auto 130px;
  text-align: center;
  background: url("../../src/assets/images/more.png") no-repeat;
  background-size: 100% 100%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff5ea;
  cursor: pointer;
}

.dzyjbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.dzyjitem {
  display: flex;
  border-bottom: 1px dashed #EAE0D5;
}

.b_26 {
  height: 26px;
}

.dzyjitemcontent {
  width: 180px;
  height: 200px;
  background: url("../../src/assets/images/dzjjbox.png") no-repeat;
  background-size: 100% 100%;
  padding: 21px;
}

.jyzjbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.jyzjbox .jyzj_left {
  width: 320px;
  height: 320px;
  background: url("../../src/assets/images/jyzjbox.png") no-repeat;
  background-size: 100% 100%;
  padding: 21px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.jyzjbox .jyzj_left img {
  width: 100%;
  height: 158px;
}

.jyzj_left_time {
  font-size: 14px;
  font-family: Helvetica;
  color: #391603;
  line-height: 17px;
  margin-top: 16px;
}

.jyzj_left_title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #391603;
  line-height: 20px;
  margin: 13px 0 8px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.jyzj_left_desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.jyzj_right {
  width: 660px;
  height: 320px;
  background: url("../../src/assets/images/jyzjright.png") no-repeat;
  background-size: 100% 100%;
  padding: 29px;
  display: flex;
  flex-direction: column;
}

.jyItem {
  display: flex;
  margin-bottom: 24px;

}

.jyItem_left {
  font-size: 14px;
  font-family: Helvetica;
  color: #391603;
  line-height: 17px;
  padding-right: 16px;
  width: 25%;
}

.jyItem_right {
  padding-left: 16px;
  border-left: 1px solid #eae0d5;
  text-align: justify;
  width: 75%;
  cursor: pointer;
}

.yItem_title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #391603;
  line-height: 20px;
  margin-bottom: 5px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.yItem_desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dxbabox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.dxbaItem {
  display: flex;
  flex-direction: column;
  width: 129px;
  height: 360px;
  background: url("../../src/assets/images/dxbabox.png") no-repeat;
  background-size: 100% 100%;
  padding: 21px;
  cursor: pointer;
}

.dxbaItemBottom {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.dxbaTitle {
  writing-mode: vertical-rl;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #553827;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 255px;
}

.dxbadesc {
  writing-mode: vertical-rl;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 16px;
}

.mtbdbox {
  display: flex;
  flex-wrap: wrap;
  height: 314px;
  justify-content: space-between;
  align-items: center;
  padding: 26px 69px;
  background: url("../../src/assets/images/mtbdbox.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 0;
}

.mtbdItem {
  display: flex;
  width: 408px;
  align-items: baseline;
  cursor: pointer;
}

.mtbdItem_left {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #af1f23;
  margin-right: 16px;
}

.mtbdItem_title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #391603;
  line-height: 20px;
  margin-bottom: 5px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mtbdItem_time {
  font-size: 12px;
  font-family: Helvetica;
  color: #391603;
  line-height: 14px;
}

.el-backtop {
  width: 72px;
  height: 108px;
  background: url("../../src/assets/images/top.png") no-repeat;
  background-size: 100% 100%;
  border-radius: initial;
}

.spzlBox {
  width: 100%;
  height: 245px;
  background: url("../../src/assets/images/sjz.png") no-repeat center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 43px auto 0;
}

.spzlDiv {
  width: 402px;
  height: 245px;
  background: url("../../src/assets/images/spzldiv.png") no-repeat;
  background-size: 100% 100%;
}

.spzlDiv+.sptime {
  bottom: -40px !important;
}

.spzlDiv+.sptime+.sptitle {
  bottom: -70px !important;
}

.spItem {
  position: relative;
  width: 100%;
  cursor: pointer;
  margin-right: 5px;
}

.spImg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spImg img {
  border-radius: 5px;
}

.sptime {
  position: absolute;
  bottom: -40px;
  font-size: 14px;
  font-family: Helvetica;
  color: #391603;
  line-height: 17px;
}

.sptitle {
  position: absolute;
  bottom: -70px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #391603;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.spItem:nth-of-type(odd) .sptime {
  bottom: 30px;
}

.spItem:nth-of-type(odd) .sptitle {
  bottom: 10px;
}</style>